
export default {
  name: 'DoYouReallyWant',
  props: {
    outlined: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: undefined
    },
    maxWidth: {
      type: String,
      default: '400px'
    },
    exec: {
      type: Function,
      default: () => {
      }
    },
    execNo: {
      type: Function,
      default: () => {
      }
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      required: true
    },
    dialogTitle: {
      type: String,
      default: undefined
    },
    dialogText: {
      type: String,
      required: true
    },
    dialogTextMore: {
      type: String,
      default: undefined
    },
    disabledYesButton: {
      type: Boolean,
      default: false
    },
    yesButtonText: {
      type: String,
      default () {
        return this.$t('submit')
      }
    },
    noButtonText: {
      type: String,
      default () {
        return this.$t('cancel')
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    maxWidthComputed () {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : this.maxWidth
    },
    buttonSize () {
      const size = { xs: 'large' }[this.$vuetify.breakpoint.name]
      return size ? { [size]: true } : {}
    }
  },
  methods: {
    async yes () {
      this.loading = true
      await this.exec()
      this.loading = false
      this.dialog = false
    },
    no () {
      this.execNo()
      this.dialog = false
    }
  }
}
